import {Component, OnInit, inject, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {EventsManager} from 'src/app/services/events.manager';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  imports: [NgIf]
})

export class LoadingComponent implements OnInit {
  private _destroyRef = inject(DestroyRef);

  public eventsManager = inject(EventsManager);

  public showLoading: boolean = false;

  public ngOnInit(): void {
    this.eventsManager.loadingState
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((result: boolean) => {
        this.showLoading = result;
      });
  }
}
